(function () {
  'use strict';

  var nav = document.getElementById('SpyrNav');
  if (!nav) return;
  var toggle = nav.querySelector('[data-nav-toggle]');
  if (!toggle) return;

  function open() {
    nav.classList.add('is-menu-open');
    toggle.setAttribute('aria-expanded', 'true');
    toggle.setAttribute('aria-label', 'Close menu');
  }

  function close() {
    nav.classList.remove('is-menu-open');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-label', 'Open menu');
  }

  toggle.addEventListener('click', function () {
    if (nav.classList.contains('is-menu-open')) close();
    else open();
  });

  // Close when an in-panel link is tapped
  nav.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('[data-nav-link]');
    if (link) close();
  });

  // Close on outside tap
  document.addEventListener('click', function (e) {
    if (!nav.classList.contains('is-menu-open')) return;
    if (nav.contains(e.target)) return;
    close();
  });

  // Close on Esc
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && nav.classList.contains('is-menu-open')) close();
  });
})();
